import type { ReactElement } from 'react'
import type { MessageSendingInfo } from '~/api/queries/global'
import { Alert, AlertVariation } from '~/components/Global/Interactions/Alert'
import { useActiveAgency } from '~/domains/users/hooks/useActiveAgency'

type SmsAlertsProps = {
  isLoading?: boolean
  sendingInfo?: MessageSendingInfo
  isInvalidPhone?: boolean
  acceptsMessaging?: boolean
  recipientLabel?: 'candidat' | 'contact'
  onDismiss?: () => void
}

export const SmsAlerts = ({
  isLoading = false,
  sendingInfo = undefined,
  isInvalidPhone,
  acceptsMessaging,
  recipientLabel = 'candidat',
  onDismiss
}: SmsAlertsProps): ReactElement | null => {
  const { activeAgency, isLoading: isAgencyLoading } = useActiveAgency()
  const hasCredits = (sendingInfo?.smsRemaining ?? 0) > 0

  if (sendingInfo && sendingInfo.service == null) {
    return (
      <Alert
        onDismiss={onDismiss ?? false}
        variation={AlertVariation.Warning}
        message="Le service d'envoi de SMS n'est pas configuré pour votre agence. Vous ne pouvez pas envoyer de message."
      />
    )
  }

  if (!isAgencyLoading && activeAgency === null) {
    return (
      <Alert
        onDismiss={onDismiss ?? false}
        variation={AlertVariation.Warning}
        message="Vous devez être associé à une agence pour envoyer un SMS. Veuillez contacter votre administrateur."
      />
    )
  }

  if (sendingInfo && !isLoading && hasCredits === false) {
    return (
      <Alert
        onDismiss={onDismiss ?? false}
        variation={AlertVariation.Warning}
        message="Crédits épuisés. Veuillez contacter votre administrateur pour recharger vos crédits."
      />
    )
  }

  if (isInvalidPhone === true) {
    return (
      <Alert
        onDismiss={onDismiss ?? false}
        variation={AlertVariation.Warning}
        message="Le numéro mobile est invalide ou non renseigné"
      />
    )
  }

  if (acceptsMessaging === false) {
    return (
      <Alert
        onDismiss={onDismiss ?? false}
        variation={AlertVariation.Warning}
        message={`Le ${recipientLabel} ne souhaite pas être contacté par SMS`}
      />
    )
  }

  return null
}
